import { render, staticRenderFns } from "./ArticleInnerCoverFront.vue?vue&type=template&id=69f122a3&scoped=true"
import script from "./ArticleInnerCoverFront.vue?vue&type=script&lang=js"
export * from "./ArticleInnerCoverFront.vue?vue&type=script&lang=js"
import style0 from "./ArticleInnerCoverFront.vue?vue&type=style&index=0&id=69f122a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f122a3",
  null
  
)

export default component.exports